import type { OneTimeProduct, AssertProduct } from '@/store/products'

declare const _prd_63Vnvsy5CEUP: {
	id: 'prd_63Vnv2DEV2sy5CEUP'
	ident: 'prd_63Vnvsy5CEUP'
	sku: 'simple_workbook_bundle_26_usd'
	type: 'one_time'
	price: {
		price_id: 'prc_TBbyt2DEV2k2Jlcjt'
		amount: 64
		amount_usd: 26
		currency: 'USD'
		amount_with_discount: 26
		discount: 38
		promocode: 'BASE'
	}
}
type _check = AssertProduct<typeof _prd_63Vnvsy5CEUP, OneTimeProduct>
const prd_63Vnvsy5CEUP = { ident: 'prd_63Vnvsy5CEUP' } as typeof _prd_63Vnvsy5CEUP

export default prd_63Vnvsy5CEUP
